import { toast } from 'sonner';
import { useApiQuery } from '@/hooks/useApiQuery';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiGet, apiPost, operationsClient } from '@/lib/api';
import { emailTemplateEndpoints } from '@/lib/api/endpoints';
import { emailTemplateKeys } from '@/lib/queryKeys';
import type {
  EmailTemplateFull,
  EmailTemplateStarterSummary,
  EmailTemplateKind,
} from '@/types/emailTemplate';

/** Platform starters for a kind — finished designs a tenant can make its own. */
export function useEmailTemplateStarters(kind: EmailTemplateKind) {
  return useApiQuery<EmailTemplateStarterSummary[]>({
    queryKey: emailTemplateKeys.starters(kind),
    queryFn: () =>
      apiGet<EmailTemplateStarterSummary[]>(
        operationsClient,
        emailTemplateEndpoints.starters(kind),
      ),
    showErrorToast: false,
  });
}

/** "Use this starter": clones it into a new DRAFT design owned by this tenant. */
export const useUseEmailTemplateStarter = createMutationHook<EmailTemplateFull, { slug: string }>({
  mutationFn: ({ slug }) =>
    apiPost<EmailTemplateFull, undefined>(
      operationsClient,
      emailTemplateEndpoints.useStarter(slug),
    ),
  onSuccess: (data, _vars, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: emailTemplateKeys.lists() });
    void queryClient.invalidateQueries({ queryKey: emailTemplateKeys.detail(data.id) });
    toast.success('Starter added as a draft — publish it when it is ready');
  },
});
